
<template>
	    <l-map v-if="mapStyle !== null" 
		  :zoom="data.map_data.zoom"
          :center="[data.map_data.latitude, data.map_data.longitude]"
          :options="mapOptions"
		  :ref="data.map_data.map_ele"
          @update:center="centerUpdate"
          @update:zoom="zoomUpdate">
          <l-tile-layer
            :url="mapStyle.url"
            :attribution="mapStyle.attribution"
			:tileSize="512"
    		:options="{zoomOffset: -1}"
          />
          <v-marker-cluster v-if="mapType === 'markerCluster'" :options="markerCluster.options">
            <l-marker v-for="(item, idx) in data.map_data.markers" :key="idx" :lat-lng="[item.latitude, item.longitude]">
              <l-popup v-if="item.open_marker_popup == 1">
                <div v-on:click="innerClick" v-html="func_setMarkerInfo(item)">

                </div>
              </l-popup>
            </l-marker>
          </v-marker-cluster>
		  <!-- <div v-else-if="mapType === 'geojson'" v-for="(gj, idx) in data.map_data.geo_data" :key="idx"> -->
	          <!-- <l-marker :lat-lng="gj.center" :icon="gj.properties.marker.icon"></l-marker> -->
	      <l-geo-json v-else-if="mapType === 'geojson'" :geojson="data.map_data.geo_data" :options="geoJson.geoJsonOpts"></l-geo-json>
	      <!-- </div> -->
        </l-map>
</template>

<script>
import { LMap, LTileLayer, LMarker, LPopup, LGeoJson } from 'vue2-leaflet';

export default {
	props: ['mapType', 'mapStyle', 'data', 'func_setMarkerInfo'],
	name: 'LMapWrapper',
	components: {
		LMap,
		LTileLayer,
		LMarker,
		'VMarkerCluster': () => import(/* webpackChunkName: "g_map" */ 'vue2-leaflet-markercluster'),
		LPopup,
		LGeoJson
	},
	data() {
		return {
	        urls: [
				{
					'name': 'Normal',
					'url':'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
					'attribution': '<a href="https://www.openstreetmap.org/copyright" target="_blank">&copy; OpenStreetMap contributors</a>'
				},
				{
					'name': 'Satelite',
					'url': 'https://api.maptiler.com/maps/hybrid/{z}/{x}/{y}.jpg?key=hOgNjz7vIUx6RTlMKlJq',
					'attribution': '<a href="https://www.maptiler.com/copyright/" target="_blank">&copy; MapTiler</a> <a href="https://www.openstreetmap.org/copyright" target="_blank">&copy; OpenStreetMap contributors</a>'
				},
				{
					'name': 'Pastel',
					'url': 'https://api.maptiler.com/maps/pastel/{z}/{x}/{y}.png?key=hOgNjz7vIUx6RTlMKlJq',
					'attribution': '<a href="https://www.maptiler.com/copyright/" target="_blank">&copy; MapTiler</a> <a href="https://www.openstreetmap.org/copyright" target="_blank">&copy; OpenStreetMap contributors</a>'
				},
				{
					'name': 'Streets',
					'url': 'https://api.maptiler.com/maps/streets/{z}/{x}/{y}.png?key=hOgNjz7vIUx6RTlMKlJq',
					'attribution': '<a href="https://www.maptiler.com/copyright/" target="_blank">&copy; MapTiler</a> <a href="https://www.openstreetmap.org/copyright" target="_blank">&copy; OpenStreetMap contributors</a>'
				},
				{
					'name': 'Toner',
					'url': 'https://api.maptiler.com/maps/toner/{z}/{x}/{y}.png?key=hOgNjz7vIUx6RTlMKlJq',
					'attribution': '<a href="https://www.maptiler.com/copyright/" target="_blank">&copy; MapTiler</a> <a href="https://www.openstreetmap.org/copyright" target="_blank">&copy; OpenStreetMap contributors</a>'
				},
				{
					'name': 'Hillshades',
					'url': 'https://api.maptiler.com/tiles/hillshades/{z}/{x}/{y}.png?key=hOgNjz7vIUx6RTlMKlJq',
					'attribution': '<a href="https://www.maptiler.com/copyright/" target="_blank">&copy; MapTiler</a> <a href="https://www.openstreetmap.org/copyright" target="_blank">&copy; OpenStreetMap contributors</a>'
				}
			],
	        attribution: '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
	        mapOptions: {
	          zoomSnap: 0.5,
	          /*zoomControl: false,*/
	          scrollWheelZoom: false,
			  dragging: !L.Browser.mobile
	        },
			markerCluster: { 
				options: {maxClusterRadius: 55, /*showCoverageOnHover: false*/
					/*iconCreateFunction: function (cluster) {
					var markers = cluster.getAllChildMarkers();
					console.log(markers);
					console.log(markers.length);
					return L.divIcon({ html: '<div><span>' + markers.length + ' p</span></div>', className: 'marker-cluster marker-cluster-small', iconSize: L.point(32, 32) });
					}*/
				},
			},
			geoJson: {
				geoJsonOpts: null,
			}
		}
	},
	methods: {
		centerUpdate: function() {
	      /*console.log('centerUpdate');*/
	    },
	    zoomUpdate: function() {
	      /*console.log('zoomUpdate');*/
	    },
	    innerClick: function() {
	      /*console.log(innerClick);*/
	    },
		layer_clicked: function(feature, layer) {
	      if(this.prevLayerClicked !== null) {
	        this.prevLayerClicked.layer.setStyle(this.prevLayerClicked.feature.properties.style);
	        //this.prevLayerClicked.layer.bringToBack();
	      }
	      layer.setStyle({
	        fillOpacity: 1,
	      });
	      layer.bringToFront(); // set z-index all others
	      this.prevLayerClicked = {feature: layer.feature, layer: layer};
	    },
	    trigger_popup: function(id, ref) {
	      var that = this;
	      this.$refs[ref].mapObject.eachLayer(function(layer) {
	        if(typeof layer.feature !== 'undefined' && layer.feature.id === id) {
	          that.layer_clicked(layer.feature, layer);
	          layer.openPopup();
	          return false;
	        }
	      });
	    }
	},
	created: function() {
		this.$emit('setStyles', this.urls);
		if(this.mapType === 'geojson') {
			this.prevLayerClicked = null;
			var that = this;
			this.geoJson.geoJsonOpts = {
	          style: function style(feature) {
	            return feature.properties.style;
	          },
	          /*pointToLayer: function (feature,latLng) {
				console.log(feature);
				console.log(latLng);
	            return ;
	          },*/
	          onEachFeature: function onEachFeature(feature, layer) {
				if(typeof feature.properties.infowindow !== 'undefined') {
		            layer.getLatLng = function() { return this.getBounds().getCenter() }
		            layer.on('mouseover', () => {
		              layer.setStyle({
		                weight: 2,
		              });
		            });
		            layer.on('mouseout', () => {
		              // console.log(feature.properties);
		              layer.setStyle({weight: feature.properties.style.weight}); 
		            });
		            layer.on('click', function(e) {
		              that.layer_clicked(feature, layer);
		              /*if(that.prevLayerClicked !== null) {
		                that.prevLayerClicked.layer.setStyle(that.prevLayerClicked.feature.properties.style);
		                //that.prevLayerClicked.layer.bringToBack();
		              }
		              layer.setStyle({
		                fillOpacity: 1,
		              });
		              layer.bringToFront(); // set z-index all others
		              that.prevLayerClicked = {feature: feature, layer: layer};
		              // console.log(that.$refs.mapgeojson);*/
		            });
		            layer.bindPopup('<p class="m-0">'+ feature.properties.infowindow.content +'</p>');
				}
	          }
	        };
		}
	}
}
</script>
<style scoped>
  @import '~leaflet/dist/leaflet.css';
  @import "~leaflet.markercluster/dist/MarkerCluster.css";
  @import "~leaflet.markercluster/dist/MarkerCluster.Default.css";
</style>
<style>
   .my-map-leaflet, .my-map-leaflet-container {
		width: 100%;
		height: 100%;
	}
  .my-map-leaflet .leaflet-popup-content-wrapper {
    border-radius: 5px;
  }
  .map-info-window {
    font-size: 12px;
  }
  .map-info-window table {
    border-collapse: collapse;
  }
  .map-info-window th {
    padding: 6px;
    font-size: 13px;
  }
  .map-info-window td {
    padding: 2px 6px;
    font-size: 12px;
  }
  .map-info-window td, .map-info-window th {
    text-align: center;
    border: 1px solid #747474;
  }
</style>